export default "__VITE_ASSET__BLoSAEA3__"